import React from 'react';
import { Shield, Users, Award, Lock } from 'lucide-react';
import { aboutInfo, images } from '../data/mock';

const About = () => {
  const valueIcons = {
    Profesionalismo: Shield,
    Experiencia: Award,
    Compromiso: Users,
    Confidencialidad: Lock
  };

  return (
    <section id="nosotros" className="py-20 bg-slate-900">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Sobre <span className="text-yellow-400">Nosotros</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {aboutInfo.description}
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Card Side */}
          <div className="flex flex-col justify-center">
            <div className="bg-slate-800 border border-slate-700 rounded-xl p-8 mb-6">
              <p className="text-white font-semibold text-2xl mb-4">Compromiso Legal</p>
              <p className="text-gray-300 text-lg leading-relaxed">
                Defendemos los derechos e intereses de nuestros clientes con dedicación y profesionalismo
              </p>
            </div>
          </div>

          {/* Text Side */}
          <div className="flex flex-col justify-center">
            <h3 className="text-3xl font-bold text-white mb-6">Nuestra Misión</h3>
            <p className="text-gray-300 text-lg leading-relaxed mb-8">
              {aboutInfo.mission}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-slate-800 border border-slate-700 rounded-lg p-4">
                <div className="text-3xl font-bold text-yellow-400 mb-1">100%</div>
                <div className="text-gray-400 text-sm">Dedicación</div>
              </div>
              <div className="bg-slate-800 border border-slate-700 rounded-lg p-4">
                <div className="text-3xl font-bold text-yellow-400 mb-1">24/7</div>
                <div className="text-gray-400 text-sm">Disponibilidad</div>
              </div>
            </div>

            <button 
              onClick={() => {
                const element = document.getElementById('contacto');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gray-700 hover:bg-gray-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors w-full sm:w-auto"
            >
              Agendar Consulta
            </button>
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {aboutInfo.values.map((value, index) => {
            const IconComponent = valueIcons[value.title];
            return (
              <div 
                key={index}
                className="bg-slate-800 border border-slate-700 rounded-lg p-6 hover:border-blue-600/50 transition-all duration-300 hover:shadow-lg hover:shadow-blue-600/10"
              >
                <div className="bg-gray-700 inline-flex p-3 rounded-lg mb-4">
                  <IconComponent className="text-gray-300" size={24} />
                </div>
                <h4 className="text-xl font-bold text-white mb-2">{value.title}</h4>
                <p className="text-gray-400 text-sm leading-relaxed">{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
